import {Typography} from "@material-tailwind/react";
import {ChevronUpDownIcon} from "@heroicons/react/24/outline";
import {BsEnvelope, BsEnvelopeOpen} from "react-icons/bs";
import persianNumberFormat from "../../../helper/PersianNumberFormat";
import PersianNumberFormat from "../../../helper/PersianNumberFormat";
import FileCell from "../../system/fileViewer";


const TABLE_HEAD = ["#", "عنوان", "توضیحات", "فایل", "زمان ارسال", "وضعیت"];

export function NotificationReportGrid({notifications}) {

  return (
    <div>
      <table className="mt-4 text-left w-full">
        <thead>
        <tr>
          {TABLE_HEAD.map((head, index) => (
            <th key={head}
                className="cursor-pointer border-y border-blue-gray-100 bg-blue-gray-50/50 p-4 transition-colors hover:bg-blue-gray-50">
              <Typography variant="small" color="blue-gray"
                          className="items-center gap-2 font-normal leading-none opacity-70 flex justify-center">
                {head}{" "}
                {index !== TABLE_HEAD.length - 1 && (
                  <ChevronUpDownIcon strokeWidth={2} className="h-4 w-4 sticky "/>
                )}
              </Typography>
            </th>
          ))}
        </tr>
        </thead>
        <tbody className="textCenter">
        {notifications && notifications.length > 0 && notifications.map(
          ({id, title, description, attachment, create_date, push_status}, index) => {
            const isLast = index === notifications.length - 1;
            const classes = isLast ? "p-4" : "p-4 border-b border-blue-gray-50";

            return (
              <tr key={id}>
                <td className={classes}>
                  <div className="flex justify-center">
                    <Typography color="blue-gray">
                      {persianNumberFormat(index + 1, true)}
                    </Typography>
                  </div>
                </td>
                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {title}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center hover:cursor-pointer overflow-x-clip md:hover:overflow-x-visible">
                    <Typography color="blue-gray" className="textRight">
                      {description}
                    </Typography>
                  </div>
                </td>
                <td className={classes}>
                  {attachment &&
                    <div className="flex justify-center">
                      <FileCell fileCode={attachment}/>
                    </div>
                  }
                  {!attachment &&
                    <Typography color="blue-gray" className="textRight">
                      -
                    </Typography>

                  }
                </td>
                <td className={classes}>
                  <div className="flex justify-center">
                    <Typography color="blue-gray">
                      {PersianNumberFormat(create_date)}
                    </Typography>
                  </div>
                </td>
                <td className={classes}>
                  <div className="flex justify-center ">
                    {push_status === 'unread' &&
                      <BsEnvelope size={30}/>
                    }
                    {push_status === 'read' &&
                      <BsEnvelopeOpen size={30}/>}
                  </div>
                </td>

              </tr>
            );
          },
        )}
        </tbody>
      </table>
      {notifications && notifications.length === 0 &&
        <div className="text-center mt-8">
          <Typography>
            پیامی برای کاربر ارسال نشده است
          </Typography>
        </div>
      }
    </div>
  );
}